const input = {
    username: 'Benutzername',
    password: 'Passwort',
    email: 'Email',
    phone_number: 'Telefonnummer',
    confirm_password: 'Passwort bestätigen',
    search_region_code: 'Suche region code',
    backup_code: 'Backup-Code',
    code: 'Code',
    label_with_optional: '{{label}} (Optional)',
    email_address: 'E-Mail-Adresse',
    email_placeholder: 'E-Mail-Adresse eingeben',
    enter_email: 'E-Mail eingeben',
};
export default Object.freeze(input);
